<div class="time-slot-box-container">
  <app-time-period-time-slot *ngIf="isTimePeriodTimeSlot" [bookingSlot]="bookingSlot"></app-time-period-time-slot>
  <app-default-time-slot *ngIf="isDefaultTimeSlot" [bookingSlot]="bookingSlot"></app-default-time-slot>
</div>
